export default "__VITE_ASSET__DxsQr94p__"